<div class="top_container">
    <div class="title">{{ "validate_block.title" | translate}}</div>
    <img class="quit_cross" src="assets/images/quit_cross.svg" (click)="onNoClick()">
</div>
<div class="body">
    <div class="user_choice">
        <ng-template [ngIf]="chosenPickup">
            <div class="chosen_address">{{chosenPickup.label}}</div>
            <div class="chosen_pickup">{{chosenPickup.line2}}
                {{chosenPickup.line3}} {{chosenPickup.zipCode}} {{chosenPickup.city}}
            </div>
        </ng-template>
        <ng-template [ngIf]="chosenDay">
            <div class="subtitle_home"> {{ "validate_block.subtitle_home" | translate }}</div>
            <div class="date">{{chosenDay | date:"EEEE d MMMM yyyy" :'': 'fr' }}</div>
        </ng-template>
    </div>
    <div class="email">
        <app-personnal-infos [emailFromWS]="email" (emailBoolean)="checkEmail($event)" (emailInput)="saveEmail($event)">
        </app-personnal-infos>
    </div>
</div>
<div class="validate_container">
    <div class="action_button modify" (click)="modify()"> {{ "button.modify" | translate}} </div>
    <div class="action_button" (click)="isEmailValid ? validate(email):''"> {{ "button.confirm_informations" | translate}} </div>
</div>
<app-popin-footer></app-popin-footer>